 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"jspdf":"jspdf","html2canvas":"html2canvas","archive-overlay":"archive-overlay","neural-overlay":"neural-overlay","gamify-overlay":"gamify-overlay"}[chunkId]||chunkId) + "." + {"chunk-0273d434":"193c0b77","chunk-0374036b":"5e57da85","chunk-0b759c92":"53583eab","chunk-21582db5":"8b49449c","chunk-62879d20":"4bf5ff7c","chunk-0b82ab9f":"f5be951e","chunk-0fe4d7c5":"ccba1683","chunk-1d41cf92":"3bab2ae2","chunk-2242c467":"f18e4019","chunk-24eaef84":"59555bb7","chunk-29ff629d":"f8c9b822","chunk-483f7271":"3baae645","chunk-b84afe7a":"a25226b3","chunk-2c516c9e":"48dd5b4e","chunk-2d0baaab":"4e4eb64e","chunk-2d936edb":"21cfd494","chunk-2f982ae7":"073d2ac1","chunk-3027d11e":"e83bcce5","chunk-31d9c98f":"76603160","chunk-35b8ec1d":"33d42db4","chunk-25dd360a":"927e90c4","chunk-2d2248b6":"32e29157","chunk-7717125e":"0ef1fdf2","chunk-7adbffb6":"8ae23ba0","chunk-2d52e78c":"1ad6bb88","chunk-3c1b9feb":"0c583386","chunk-4002f126":"174b84f4","chunk-58276094":"06da0970","jspdf":"557e7160","chunk-3a3fcb61":"84b36c15","chunk-3d8fe804":"0e5f04c7","chunk-375db547":"9ccdb56b","chunk-2862a0aa":"b195055c","chunk-6295c071":"40f6635a","chunk-37c738d8":"c6ba1720","chunk-3b4442f1":"9a108e87","chunk-3c251508":"5084c5fb","chunk-3d1cb844":"3b9e84b4","chunk-3d546e1e":"54001a93","chunk-3d5fbc63":"14dcc93a","chunk-406e901c":"2e2c6336","chunk-43a6e368":"2c5adf9d","chunk-09e8ffc0":"b057718d","chunk-0b592a42":"eec13f4f","chunk-1c449b6b":"08fe1dc8","chunk-42cb8236":"9d655c39","chunk-4773d6f9":"89672845","chunk-7a5fb07b":"2d19ef59","chunk-7eba0915":"cb49bd63","chunk-e3cc721c":"c8fb40df","chunk-45d02f3c":"3254ed07","chunk-10395b3a":"fe648399","chunk-4757be32":"39285226","chunk-4870121a":"f2f5fda2","chunk-4954b6dc":"77da09eb","chunk-3719437c":"37d8961b","chunk-7573811f":"9c2a64c7","chunk-4969f5fc":"d7115f69","chunk-5244fc52":"311965c3","chunk-53ade66e":"854ff87b","chunk-5b7072ee":"436da8ff","chunk-72fd7e94":"6edc5abf","chunk-7457ac66":"9ab6cec3","chunk-774c4730":"aa2d8b45","chunk-7e15233a":"cfa3ed3d","chunk-03bcd0d1":"26322d82","chunk-05ad73cc":"9bb35f70","chunk-06c6dab7":"65cf3e8f","chunk-0c57e8e9":"c96e0098","chunk-3cfe8340":"f34dd60f","chunk-504948d3":"764a4358","chunk-e5bafa0e":"1ae4b195","chunk-0e49ab7d":"dd35d68c","chunk-138c7508":"0564c60b","chunk-03b338b3":"48b93de4","chunk-4dbde7c4":"711e3c9b","chunk-1503be32":"80ca9505","chunk-54d3af56":"680ceace","chunk-17b48a39":"d942da82","chunk-1471320f":"e546550b","chunk-bb725652":"3566644d","chunk-ec30440c":"590b1143","chunk-7a29022e":"6fc69a17","chunk-428a68b4":"d4582cf5","chunk-04bce8d8":"8806b13e","chunk-54dd1218":"75f710f7","chunk-70fe128f":"a2c76ac0","chunk-1e3b8da2":"5b41be4d","chunk-5fc60736":"8f11367f","chunk-449393ff":"8f08d350","chunk-5e79ee10":"032b88fe","chunk-71d2ccd0":"b1b3e2ec","chunk-dd9f45b8":"e41fec32","chunk-e6fe9b28":"c17d1803","chunk-49524bee":"a2c0ea6c","chunk-e77c0602":"ed51680b","chunk-eb6055ba":"8211be7c","chunk-7e260f2c":"062aa533","chunk-7eb384c4":"60dcaccb","chunk-92a35da4":"ffb2de58","chunk-97e1ca80":"a0a38afb","chunk-a67c6316":"7419b4ce","chunk-ab6f377a":"e4e71d87","chunk-c35c6d7e":"bd8cc7e9","chunk-c9f8b7a2":"49dcfc3f","chunk-d4548a2a":"94e0028b","chunk-e5564ce4":"f47886b4","chunk-09b07921":"68951c49","chunk-f39ac982":"822efdab","chunk-4bb332a7":"a84921fc","chunk-5be9f584":"887cacfc","chunk-aa842b28":"ffdfd1dc","chunk-1dff3a86":"969dcc15","chunk-77e877e4":"d957b89f","chunk-b9427116":"f97f4642","chunk-13ede473":"8a390d99","chunk-2d0b5a04":"3e7d4df0","chunk-25db6180":"a328aeff","chunk-2d216214":"fe4bb11d","html2canvas":"e2af4de8","chunk-91b9b31c":"c622d469","chunk-54cba802":"e7ce7d87","archive-overlay":"d18fbf3e","neural-overlay":"2fff29fc","gamify-overlay":"173d2b36"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0273d434":1,"chunk-0374036b":1,"chunk-21582db5":1,"chunk-62879d20":1,"chunk-0b82ab9f":1,"chunk-0fe4d7c5":1,"chunk-1d41cf92":1,"chunk-2242c467":1,"chunk-24eaef84":1,"chunk-29ff629d":1,"chunk-483f7271":1,"chunk-b84afe7a":1,"chunk-2c516c9e":1,"chunk-2d936edb":1,"chunk-2f982ae7":1,"chunk-3027d11e":1,"chunk-31d9c98f":1,"chunk-25dd360a":1,"chunk-7717125e":1,"chunk-7adbffb6":1,"chunk-2d52e78c":1,"chunk-3c1b9feb":1,"chunk-4002f126":1,"chunk-58276094":1,"chunk-3a3fcb61":1,"chunk-3d8fe804":1,"chunk-2862a0aa":1,"chunk-6295c071":1,"chunk-37c738d8":1,"chunk-3b4442f1":1,"chunk-3c251508":1,"chunk-3d1cb844":1,"chunk-3d546e1e":1,"chunk-3d5fbc63":1,"chunk-406e901c":1,"chunk-09e8ffc0":1,"chunk-0b592a42":1,"chunk-1c449b6b":1,"chunk-42cb8236":1,"chunk-4773d6f9":1,"chunk-7a5fb07b":1,"chunk-7eba0915":1,"chunk-e3cc721c":1,"chunk-45d02f3c":1,"chunk-10395b3a":1,"chunk-4757be32":1,"chunk-4870121a":1,"chunk-3719437c":1,"chunk-7573811f":1,"chunk-4969f5fc":1,"chunk-5244fc52":1,"chunk-53ade66e":1,"chunk-5b7072ee":1,"chunk-72fd7e94":1,"chunk-7457ac66":1,"chunk-7e15233a":1,"chunk-03bcd0d1":1,"chunk-05ad73cc":1,"chunk-06c6dab7":1,"chunk-0c57e8e9":1,"chunk-3cfe8340":1,"chunk-504948d3":1,"chunk-e5bafa0e":1,"chunk-0e49ab7d":1,"chunk-138c7508":1,"chunk-03b338b3":1,"chunk-4dbde7c4":1,"chunk-1503be32":1,"chunk-54d3af56":1,"chunk-17b48a39":1,"chunk-1471320f":1,"chunk-bb725652":1,"chunk-ec30440c":1,"chunk-7a29022e":1,"chunk-428a68b4":1,"chunk-04bce8d8":1,"chunk-54dd1218":1,"chunk-70fe128f":1,"chunk-1e3b8da2":1,"chunk-5fc60736":1,"chunk-449393ff":1,"chunk-5e79ee10":1,"chunk-71d2ccd0":1,"chunk-dd9f45b8":1,"chunk-49524bee":1,"chunk-e77c0602":1,"chunk-eb6055ba":1,"chunk-7e260f2c":1,"chunk-7eb384c4":1,"chunk-92a35da4":1,"chunk-97e1ca80":1,"chunk-a67c6316":1,"chunk-ab6f377a":1,"chunk-c35c6d7e":1,"chunk-c9f8b7a2":1,"chunk-d4548a2a":1,"chunk-e5564ce4":1,"chunk-09b07921":1,"chunk-f39ac982":1,"chunk-4bb332a7":1,"chunk-5be9f584":1,"chunk-aa842b28":1,"chunk-1dff3a86":1,"chunk-77e877e4":1,"chunk-b9427116":1,"chunk-13ede473":1,"chunk-91b9b31c":1,"chunk-54cba802":1,"archive-overlay":1,"neural-overlay":1,"gamify-overlay":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"jspdf":"jspdf","html2canvas":"html2canvas","archive-overlay":"archive-overlay","neural-overlay":"neural-overlay","gamify-overlay":"gamify-overlay"}[chunkId]||chunkId) + "." + {"chunk-0273d434":"5afd6957","chunk-0374036b":"63c71965","chunk-0b759c92":"31d6cfe0","chunk-21582db5":"5a244edf","chunk-62879d20":"39705594","chunk-0b82ab9f":"827c5f35","chunk-0fe4d7c5":"88f3e412","chunk-1d41cf92":"c81be355","chunk-2242c467":"f8aba957","chunk-24eaef84":"a560723f","chunk-29ff629d":"ded8feb5","chunk-483f7271":"8831de9e","chunk-b84afe7a":"e2baaca8","chunk-2c516c9e":"a58d7d8f","chunk-2d0baaab":"31d6cfe0","chunk-2d936edb":"9e64d2ca","chunk-2f982ae7":"ddfd6d8b","chunk-3027d11e":"c79dfa83","chunk-31d9c98f":"04ae16a3","chunk-35b8ec1d":"31d6cfe0","chunk-25dd360a":"c9e7bc0d","chunk-2d2248b6":"31d6cfe0","chunk-7717125e":"4facd137","chunk-7adbffb6":"e8d3ce1c","chunk-2d52e78c":"8be1856f","chunk-3c1b9feb":"8be1856f","chunk-4002f126":"313544f9","chunk-58276094":"445479cc","jspdf":"31d6cfe0","chunk-3a3fcb61":"a27a1642","chunk-3d8fe804":"de46c495","chunk-375db547":"31d6cfe0","chunk-2862a0aa":"de776761","chunk-6295c071":"fbd7f47e","chunk-37c738d8":"56e601cf","chunk-3b4442f1":"dbd9b83b","chunk-3c251508":"2a058810","chunk-3d1cb844":"5e1630bf","chunk-3d546e1e":"050f707d","chunk-3d5fbc63":"3974f107","chunk-406e901c":"c9d886bc","chunk-43a6e368":"31d6cfe0","chunk-09e8ffc0":"c7e40308","chunk-0b592a42":"0aba0daa","chunk-1c449b6b":"3cbea89f","chunk-42cb8236":"6687dcae","chunk-4773d6f9":"902df9d3","chunk-7a5fb07b":"3a759a4d","chunk-7eba0915":"34476734","chunk-e3cc721c":"75e893e0","chunk-45d02f3c":"eafe64b7","chunk-10395b3a":"070570e8","chunk-4757be32":"bf289549","chunk-4870121a":"6a2a481a","chunk-4954b6dc":"31d6cfe0","chunk-3719437c":"9de374d4","chunk-7573811f":"c10792bd","chunk-4969f5fc":"ab5b0470","chunk-5244fc52":"9c390c82","chunk-53ade66e":"04809417","chunk-5b7072ee":"bde6e364","chunk-72fd7e94":"edd41806","chunk-7457ac66":"796873e2","chunk-774c4730":"31d6cfe0","chunk-7e15233a":"749aed17","chunk-03bcd0d1":"a0761086","chunk-05ad73cc":"c5a2dd8f","chunk-06c6dab7":"50a57f2c","chunk-0c57e8e9":"b7bc8d22","chunk-3cfe8340":"cc3fbc89","chunk-504948d3":"a2fa5965","chunk-e5bafa0e":"987a1b30","chunk-0e49ab7d":"c138d774","chunk-138c7508":"f507b70c","chunk-03b338b3":"fd101e6d","chunk-4dbde7c4":"1526ac61","chunk-1503be32":"8b2d4cbc","chunk-54d3af56":"803efbae","chunk-17b48a39":"b0facfde","chunk-1471320f":"da4b7ae1","chunk-bb725652":"34d328af","chunk-ec30440c":"d0ba9718","chunk-7a29022e":"71e44ee3","chunk-428a68b4":"a40930cb","chunk-04bce8d8":"8f749324","chunk-54dd1218":"fa6d51bc","chunk-70fe128f":"29831e4e","chunk-1e3b8da2":"653cc0ed","chunk-5fc60736":"f85eab61","chunk-449393ff":"026f15b0","chunk-5e79ee10":"253d219c","chunk-71d2ccd0":"a52c4770","chunk-dd9f45b8":"992aea07","chunk-e6fe9b28":"31d6cfe0","chunk-49524bee":"4e2bf35c","chunk-e77c0602":"b8e384e8","chunk-eb6055ba":"f3957ecf","chunk-7e260f2c":"fd9bd485","chunk-7eb384c4":"104962aa","chunk-92a35da4":"54ffe08b","chunk-97e1ca80":"a1d4d0db","chunk-a67c6316":"078d170a","chunk-ab6f377a":"f7921759","chunk-c35c6d7e":"5a3d22a7","chunk-c9f8b7a2":"20555401","chunk-d4548a2a":"6b4026bf","chunk-e5564ce4":"36ec23a3","chunk-09b07921":"0186aff2","chunk-f39ac982":"d5dbd123","chunk-4bb332a7":"cc12b6b1","chunk-5be9f584":"93a55777","chunk-aa842b28":"6e95290b","chunk-1dff3a86":"1234d7a5","chunk-77e877e4":"55f335a7","chunk-b9427116":"e4bdb711","chunk-13ede473":"3974f107","chunk-2d0b5a04":"31d6cfe0","chunk-25db6180":"31d6cfe0","chunk-2d216214":"31d6cfe0","html2canvas":"31d6cfe0","chunk-91b9b31c":"cc1a99d0","chunk-54cba802":"36ec23a3","archive-overlay":"8f22add0","neural-overlay":"d5abedda","gamify-overlay":"ef9c041e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
